import { connect } from 'react-redux'
import RecentStories from 'pages/currentawarenessarticle/RecentStories'

const mapStateToProps = (state, ownProps) => ({
  homepageArticles: state.ca.homepageArticles,
  aol: ownProps.aol,
  isLogged: state.user.isLogged
})

export default connect(mapStateToProps, null)(RecentStories)
